import React from 'react'

function HorizontalLine() {
  return (
    <div className='-z-0'>
        <hr className="w-48 h-1 mx-auto my-4  border-0 rounded md:my-10 dark:bg-fLetter"></hr>
    </div>
  )
}

export default HorizontalLine